import { useNavigation } from '@react-navigation/native';
import { useEffect } from 'react';

import { DEFAULT_JOURNEY, HOME_ROUTE } from '~config/navigation';

export function FourOhFourScreen() {
  const navigation = useNavigation();

  useEffect(() => {
    navigation.navigate(HOME_ROUTE, { journey: DEFAULT_JOURNEY });
  }, []);

  return null;
}
